<div style="margin: 0; padding: 0;" class="p-d-inline">
  <svg (click)="registerFavorite()" xmlns="http://www.w3.org/2000/svg" class="pointer" width="15" height="15"
       viewBox="0 0 20 19" style="margin-right: 0.5em;" >
    <path class="{{isFavorite ? 'full-star' : 'empty-star'}}"
          d="M10,0l2.7,6.791,7.3.467-5.631,4.663L16.18,19,10,15.091,3.82,19l1.812-7.079L0,7.257l7.3-.467Z"/>
  </svg>
</div>
